'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchResultItem = require('./components/SearchResultItem.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SearchResultItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/search-result-item/index.js
// module id = 923
// module chunks = 0